import { inject, observer } from 'mobx-react';
import React from 'react';
import AppNavigation from './Navigation';
// Import styles
import styles from './style.scss';
// Import children
import AppTitle from './Title';

/**
 * AppHeader component, render only
 */
const AppHeader = inject('ViewStore')(observer(({ ViewStore }) => (
  <div className={styles.header} >
    {/* <AppTitle /> */}
    <AppNavigation />
  </div >
)));

export default AppHeader;
